export const LANGUAGE_TOKEN = 'romulus-lang';
